

































































































































import MealTable from '@/components/partials/MealTable.vue';
import {Component, Vue, Watch} from 'vue-property-decorator';
import MealService from '../services/MealService';
import Chart from '../app/init.vue';
import ComponentService from '@/services/ComponentService';

@Component({
  // @ts-ignore
  components: {
    MealTable, Chart
  },
})

export default class DayOverview extends Vue {
  private loading: boolean = false;
  private snackbar: boolean = false;
  private graphicDialog: boolean = false;
  private snackbarText: string = '';
  private snackbarColor: string = '';
  private selectedDay: string = '';
  private tods = {1: 'Breakfast', 2: 'Lunch', 3: 'Dinner', 4: 'Snacks', 5: 'Others'};
  private todColors = {
    1: 'cyan darken-1',
    2: 'green darken-1',
    3: 'deep-orange darken-1',
    4: 'red darken-1',
    5: 'purple darken-1'
  };
  private diet = 1;
  private totalNutrients: any = {};

  private mounted() {
    if (this.days.length === 0) {
      MealService.getMeals().then((response) => {
          this.$store.dispatch('setMeals', response.data);
      });
    }
  }

  private refreshDay() {
    this.getMeals(this.selectedDay);
  }

  private async getMeals(day: string) {
    try {
      this.loading = true;
      this.$store.dispatch('setDayFoods', []);
      const dayMeals = this.dayMeals[day];
      const promises = [];
      for (const meal of dayMeals) {
          promises.push(MealService.getMealFoods(meal.id));
      }
      const results = await Promise.all(promises);
      for (const result of results) {
          this.$store.dispatch('addDayFoods', result.data);
      }
      this.$store.dispatch('setDayMeals', dayMeals);
      this.selectedDay = day;
      this.getTotalNutrients();
      const { data } = await ComponentService.getComponents();
      this.$store.dispatch('setComponents', data);
    } catch (e) {
      this.displaySnackbar(e.message, 'error');
    } finally {
      this.loading = false;
    }
  }

  private displaySnackbar(msg: string, color: string) {
    this.snackbarText = msg;
    this.snackbarColor = color;
    this.snackbar = true;
  }

  private async updateMeal(meal: {foods: object[], id: string}) {
    try {
      this.loading = true;
      const foods = this.dayFoods.filter(
        (item: any) => parseInt(item.mealid, 10) === parseInt(meal.id, 10)
      );
      meal.foods = foods;
      await MealService.updateMeal(meal);
      this.displaySnackbar('Meal Updated!', 'blue-grey');
    } catch (e) {
      this.displaySnackbar(e.message, 'error');
    } finally {
      this.loading = false;
    }
  }

  private getMealFoods(meal: number) {
    const foods = this.dayFoods.filter((item: any) => parseInt(item.mealid, 10) === meal && !item.toRemove);
    return foods;
  }

  private async selectDiet(id: number) {
    if (!this.targets[this.diet]) {
      await this.$store.dispatch('getNutrientTargets', this.diet);
    }

    this.diet = id;
  }

  @Watch('diet')
  private onDietChange(value: number, oldValue: number) {
    this.selectDiet(value);
  }

  private getTotalNutrients() {
    const total: any = {};
    for (const food of this.dayFoods) {
      for (const key in food.nutrients) {
        if (food.nutrients.hasOwnProperty(key)) {
          total[key] = total[key] || {
            value: 0.0
          };
          const measure = food.measures.find((item: any) => item.measureid === food.portion_basis);
          const value = parseFloat(food.nutrients[key].value || 0);
          const multiplier = parseFloat(food.portion_multiplier || 1);
          const conversionFactor = parseFloat(measure.conversionfactorvalue || 1);
          total[key].value = (parseFloat(total[key].value) +
            (value * multiplier * conversionFactor)).toFixed(3);
          if (this.targetsObj[key]) {
            total[key].percent =
              (parseFloat(total[key].value) / this.targetsObj[key].target_value * 100).toFixed(1);
            if ((this.targetsObj[key].lower_limit &&
              parseFloat(total[key].value) < this.targetsObj[key].lower_limit) ||
              total[key].percent < 80) {
              total[key].color = 'red lighten-4';
            } else if (total[key].percent < 90) {
              total[key].color = 'orange lighten-4';
            } else {
              total[key].color = 'green lighten-5';
            }

            if (this.targetsObj[key].upper_limit  &&
              parseFloat(total[key].value) > this.targetsObj[key].upper_limit) {
              total[key].color = 'red lighten-4';
            }
          }
        }
      }
    }
    this.totalNutrients = total;
  }

  get meals() {
    return this.$store.getters.getMeals;
  }

  get dayFoods() {
    return this.$store.getters.getDayFoods;
  }

  get diets() {
    return this.$store.getters.getDiets;
  }

  get selectedDiet() {
    return this.diets.find((item: {id: number}) => item.id === this.diet);
  }

  get nutrients() {
    return this.$store.getters.getNutrients;
  }

  get targets() {
    return this.$store.getters.getTargets;
  }

  get dayMeals() {
    const days: any = {};
    for (const meal of this.meals) {
      if (meal.day) {
        days[meal.day] = days[meal.day] || [];
        days[meal.day].push(meal);
      }
    }
    return days;
  }

  get days() {
    const days = [];
    for (const meal of this.meals) {
      if (meal.day && days.indexOf(meal.day) === -1) {
        days.push(meal.day);
      }
    }
    return days;
  }

  get mealItems() {
    return this.$store.getters.getDayMeals;
  }

  get targetsObj() {
    const targets: any = {};
    if (this.targets && this.targets[this.diet]) {
      for (const target of this.targets[this.diet]) {
        targets[target.nutrient_id] = target;
      }
    }
    return targets;
  }
}
